<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">
            <div class="header-block">
                <div class="header-title">
                    <p style="margin: 0; font-size: 1.25rem; font-weight: 600;">Title Workflow</p>
                </div>
                <div class="add-block">
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <div class="desktop-view">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20%;">Episode Name</th>
                            <th style="width: 20%;">Episode Type</th>
                            <th style="width: 20%;">Shoot Date</th>
                            <th style="width: 20%;">Status</th>
                            <th style="width: 20%;text-align: center;padding: 0;">Action</th>
                        </tr>
                    </thead>
                </table>

                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let episode of episodeList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }">

                        <p style="width: 20%;" [title]="episode.episodeName">{{episode.episodeName || " -- " }}</p>
                        <p style="width: 20%;">{{episode.episodeType || " -- " }}</p>
                        <p style="width: 20%;">{{ (episode.shootDate && episode.shootDate !== 0 ? (episode.shootDate |
                            date:'mediumDate') : null) || " -- " }}</p>
                        <p style="width: 20%;">{{statusMap[episode.episodeStatus] || episode.episodeStatus || " -- " }}</p>

                        <p class="action-buttons" style="width: 20%;padding-left: 25px; text-align: center;">
                            <i data-toggle="modal" title="View" (click)="openTitleModal(episode)" data-target="#titleModal"
                                class="bi bi-eye-fill" style="cursor: pointer; font-size: 16px;"></i>
                        </p>
                    </div>
                </div>
            </div>

            <!-- Mobile Card View -->
            <div class="mobile-view" *ngIf="!isLoading">
                <div class="episode-card"
                    *ngFor="let episode of episodeList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }">
                    <div class="card-header">
                        <h3>{{episode.episodeName || "Unnamed Episode" }}</h3>
                        <div class="actions">
                            <i data-toggle="modal" title="View" (click)="openTitleModal(episode)" data-target="#titleModal"
                                class="bi bi-eye-fill"></i>
                        </div>
                    </div>
                    
                    <div class="status" [ngClass]="{'pending': episode.episodeStatus?.includes('PENDING'), 'inprogress': episode.episodeStatus === 'EPISODE_CREATION' || episode.episodeStatus === 'QC_REJECTED'}">
                        <i class="bi bi-check-circle-fill" *ngIf="episode.episodeStatus?.includes('COMPLETED')"></i>
                        {{statusMap[episode.episodeStatus] || episode.episodeStatus || "PENDING" }}
                    </div>

                    <div class="details">
                        <div class="detail-row">
                            <span>Id</span>
                            <strong>{{episode.tvProductionTrackerId || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Anchor</span>
                            <strong>{{episode.anchorUser || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Director</span>
                            <strong>{{episode.director || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Shoot Date</span>
                            <strong>{{ (episode.shootDate && episode.shootDate !== 0 ? (episode.shootDate | date:'mediumDate') : null) || "--" }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && episodeList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
            </div>
        </div>
    </div>
</div>

<!-- Title Modal -->
<div class="modal fade" id="titleModal" tabindex="-1" data-backdrop="static" aria-labelledby="titleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1400px;">
        <div class="modal-content ent-modal-content">
            <div class="modal-header ent-modal-header">
                <div class="ent-header-left">
                    <h5 class="modal-title ent-title" id="titleModalLabel">Title Workflow</h5>
                    <p class="ent-subtitle">{{selectedEpisode?.episodeName}}</p>
                </div>
                <div class="ent-header-right">
                    <button type="button" class="close ent-close-btn" data-dismiss="modal" aria-label="Close"
                        (click)="closeModal()" id="closeTitleModalBtn">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-body ent-modal-body" *ngIf="selectedEpisode">
                <div [formGroup]="titleForm" class="ent-grid">

                    <!-- Episode Information Card -->
                    <div class="ent-card" style="grid-column: span 2;">
                        <h5 class="ent-card-title">Episode Information</h5>
                        <div class="ent-card-grid-3">
                            <div class="ent-field"><span class="ent-label">Id</span><span
                                    class="ent-value">{{selectedEpisode?.tvProductionTrackerId || '--'}}</span>
                            </div>
                            <div class="ent-field"><span class="ent-label">Episode Name</span><span
                                    class="ent-value">{{selectedEpisode?.episodeName || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Episode Type</span><span
                                    class="ent-value">{{selectedEpisode?.episodeType || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Anchor</span><span
                                    class="ent-value">{{selectedEpisode?.anchorUser || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Director</span><span
                                    class="ent-value">{{selectedEpisode?.director || '--'}}</span></div>
                            <div class="ent-field">
                                <span class="ent-label">Guest</span>
                                <span class="ent-value">
                                    <ng-container
                                        *ngIf="selectedEpisode?.guest1">{{selectedEpisode.guest1}}</ng-container>
                                    <ng-container *ngIf="selectedEpisode?.guest1 && selectedEpisode?.guest2">,
                                    </ng-container>
                                    <ng-container
                                        *ngIf="selectedEpisode?.guest2">{{selectedEpisode.guest2}}</ng-container>
                                    <ng-container
                                        *ngIf="!selectedEpisode?.guest1 && !selectedEpisode?.guest2">--</ng-container>
                                </span>
                            </div>
                            <div class="ent-field"><span class="ent-label">Status Badge</span><span
                                    class="ent-value">{{statusMap[selectedEpisode?.episodeStatus] ||
                                    selectedEpisode?.episodeStatus || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Shoot Date</span><span class="ent-value">{{
                                    (selectedEpisode?.shootDate && selectedEpisode?.shootDate !== 0 ?
                                    (selectedEpisode?.shootDate | date:'mediumDate') : null) || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Shoot Time</span><span
                                    class="ent-value">{{selectedEpisode?.shootTime || '--'}}</span></div>
                        </div>
                    </div>

                    <!-- Video Section Placeholder -->
                    <div class="video-container"
                        style="grid-column: span 2; background: #000; border-radius: 12px; overflow: hidden; border: 1px solid rgba(255,255,255,0.1); box-shadow: 0 10px 25px rgba(0,0,0,0.5);">
                        <div class="video-wrapper"
                            style="position: relative; width: 100%; min-height: 350px; background: radial-gradient(circle at center, #1e293b 0%, #0f172a 100%); display: flex; align-items: center; justify-content: center;">

                            <div class="no-stream-content" style="text-align: center;">
                                <!-- <i class="bi bi-camera-video"
                                    style="font-size: 3.5rem; color: #3b82f6; margin-bottom: 20px; display: block; filter: drop-shadow(0 0 15px rgba(59, 130, 246, 0.4));"></i>
                                <h3 style="font-size: 1.5rem; font-weight: 700; color: #f8fafc; margin-bottom: 10px;">No
                                    Video Stream</h3> -->

                                <video controls crossorigin="anonymous"
                                    style="width: 100%; height: 100%; max-height: 500px; object-fit: contain;"
                                    src="{{videoUrl+selectedEpisode?.tvProductionTrackerId+'.mp4'}}"></video>
                            </div>
                        </div>
                    </div>

                    <div class="ent-card" *ngIf="selectedEpisode?.suggestedTitles?.length > 0">
                        <h5 class="ent-card-title">Suggested Titles</h5>
                        <ul style="padding-left: 20px; margin-bottom: 0;">
                            <li *ngFor="let st of selectedEpisode.suggestedTitles"
                                style="margin-bottom: 8px; font-size: 14px;">
                                {{st.titleName}}
                            </li>
                        </ul>
                    </div>

                    <div class="ent-card">
                        <h5 class="ent-card-title">Suggested & Approved Title</h5>
                        <div class="">
                            <div class="ent-field">
                                <label class="ent-label">Add Suggested Title</label>
                                <textarea formControlName="suggestedTitles" class="form-control" rows="3"
                                    style="border-radius: 10px; border: 1px solid #cbd5e1; padding: 16px; font-size: 1.4rem; box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.02);"></textarea>
                            </div>
                            <div class="ent-field">
                                <label class="ent-label">Approved Title</label>
                                <select formControlName="approvedTitle" class="form-control"
                                    style="border-radius: 10px; border: 1px solid #cbd5e1; padding: 12px; font-size: 1.3rem; height: auto; box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.02);">
                                    <option value="">Select Approved Title...</option>
                                    <option *ngFor="let st of selectedEpisode?.suggestedTitles" [value]="st.titleName">
                                        {{st.titleName}}</option>
                                </select>
                            </div>
                        </div>
                        <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
                            <button type="button" class="ent-btn-primary" style="background: #64748B;"
                                (click)="saveDetails(false)">Save Details</button>
                        </div>
                    </div>

                    <div class="ent-card">
                        <h5 class="ent-card-title">Chat</h5>
                        <div class="ent-notes-list mb-3" *ngIf="selectedEpisode?.commonNotes?.length > 0"
                            style="max-height: 350px; overflow-y: auto; margin-bottom: 16px;">
                            <div class="ent-note-card" *ngFor="let note of selectedEpisode.commonNotes"
                                [ngClass]="isMyNote(note) ? 'chat-bubble-mine' : 'chat-bubble-other'">
                                <p class="ent-note-body">{{note.commonNotes}}</p>
                                <div class="ent-note-footer">
                                    <div class="ent-note-user"><i class="bi bi-person-fill"></i> {{note.userName ||
                                        note.userId || 'User'}}</div>
                                    <div class="ent-note-time">
                                        <span *ngIf="note.date">{{note.date | date:'short'}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ent-field">
                            <textarea formControlName="commonNotes" class="form-control" rows="3"
                                placeholder="Type a message or note for the team..."
                                style="border-radius: 10px; border: 1px solid #cbd5e1; padding: 16px; font-size: 1.4rem; box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.02);"></textarea>
                        </div>
                        <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
                            <button type="button" class="ent-btn-primary" style="background: #64748B;"
                                (click)="sendChat()">Send</button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer ent-modal-footer" *ngIf="selectedEpisode">
                <div class="ent-footer-left">
                    <div class="ent-assignment-section">
                        <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                            <option value="">Select Quality Check User...</option>
                            <option *ngFor="let user of directorUserList" [value]="user.userName">{{user.userName}}
                            </option>
                        </select>
                        <button type="button" class="ent-btn-primary" (click)="saveDetails(true)">Complete &
                            Next</button>
                    </div>
                </div>
                <div class="ent-footer-right">
                    <button type="button" class="ent-btn-secondary" (click)="closeModal()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>